import React, { useCallback, useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';

import 'react-phone-input-2/lib/bootstrap.css';
import styles from './CustomPhoneInput.module.scss';

const CustomPhoneInput = ({ value = '', placeholder = 'Phone*', handleChange = () => {}, CustomIcon, onIconClick }) => {
  const [formValue, setFormValue] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (value) {
      setFormValue(value);
    } else {
      setFormValue('');
    }
  }, [value]);

  const handleFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleBlur = useCallback(() => {
    setIsFocused(false);
  }, []);

  return (
    <div id={styles.PhoneField}>
      <div className={styles.container}>
        <span>
          <PhoneInput
            inputClass={styles.phoneInput}
            specialLabel=""
            placeholder=""
            value={formValue}
            country="us"
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleChange}
          />
          <span className={formValue.length > 0 || isFocused ? styles.floatingLabelFocused : styles.floatingLabel}>
            {placeholder}
          </span>
          {CustomIcon && (
            <button
              style={{ cursor: `${onIconClick ? 'pointer' : 'auto'}` }}
              type="button"
              className={styles.floatingLabelIcon}
              onClick={onIconClick}
            >
              <CustomIcon />
            </button>
          )}
        </span>
      </div>
    </div>
  );
};

export default CustomPhoneInput;
